import React, { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';
import { formatDocumentInput } from 'utils/documentFormat';

const DocumentInput = forwardRef(function DocumentInput({ value, onChange, ...props }, ref) {
  const handleChange = (e) => {
    const formatted = formatDocumentInput(e.target.value);
    onChange?.({
      ...e,
      target: { ...e.target, value: formatted },
    });
  };

  return (
    <Input
      ref={ref}
      {...props}
      value={value ?? ''}
      onChange={handleChange}
      inputMode="numeric"
      autoComplete="off"
    />
  );
});

export default DocumentInput;
export { normalizeDocument, formatDocument, formatDocumentInput } from 'utils/documentFormat';
